export default __webpack_public_path__ + "static/media/feature-general.3c1fd19f.svg";